import { applyAuthHint } from "./session/auth-hint.js";

/**
 * <c>&lt;head&gt;</c> で読む入口（<c>public/js/head.js</c>）。<b>defer も async も付けずに読む</b>——
 * 最初の描画の前に動かすため。インラインの script は書かない（CSP。docs/02 §2.1）ので、自分のオリジンの外部の .js にしてある。
 *
 * <b>ここに置くのは描く前でないと間に合わないものだけ。</b>描画を止めて読むので、小さく保つ。
 * ほかは <c>main.ts</c>（本文の後で読む <c>site.js</c>）が担う。
 */
applyAuthHint();
